import { styled, Button as HoustonButton } from 'shared/Houston';

export const Button = styled(HoustonButton)`
  background-color: #fff;
  && {
    border-color: ${({ theme }) => theme.neutralColor.low.medium};
    color: ${({ theme }) => theme.neutralColor.low.medium};
  }
`;
